export const ItemProp = Object.freeze({
    Position: 'position',
    Title: 'title',
    TitleMeta: 'titleMeta',
    LabelSeparator: 'labelSeparator',
    ContentLabels: 'contentLabels',
});